import { useMutation } from "@tanstack/react-query";
import { OpenAPI } from "../generated";

export const useLoginPassword = () => {
  return useMutation({
    mutationKey: ["loginPassword"],
    mutationFn: async (data: { email: string; password: string }) => {
      const response = await fetch(`${OpenAPI.BASE}/api/users/login/password/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        throw new Error("Login failed");
      }
      return response.json();
    },
  });
};
